import { useEffect, useState } from 'react';

// v1.9.88 — mirrors Amahadari's platform.js. Church-POS is a thin-shell
// Capacitor app that loads kidusmichaelzm.com inside the WebView, so
// window.Capacitor is undefined on the live origin. Detect the APK by a
// user-agent token appended via android/app/src/main/assets/capacitor.config.json
// (appendUserAgent: "ChurchMobileApp").
export function isMobileApp() {
  if (typeof navigator === 'undefined') return false;
  return navigator.userAgent.includes('ChurchMobileApp');
}

// v1.9.116 — true on phones and in the APK. Print buttons are hidden there:
// printing from a phone isn't used, and inside the APK the print window has
// no way back. Updates on resize / rotate.
const MOBILE_QUERY = '(max-width: 768px)';
const isMobileNow = () =>
  isMobileApp() ||
  (typeof navigator !== 'undefined' && /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '')) ||
  (typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(MOBILE_QUERY).matches);

export function useIsMobile() {
  const [m, setM] = useState(isMobileNow);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mq = window.matchMedia(MOBILE_QUERY);
    const h = () => setM(isMobileNow());
    if (mq.addEventListener) mq.addEventListener('change', h); else mq.addListener(h);
    return () => { if (mq.removeEventListener) mq.removeEventListener('change', h); else mq.removeListener(h); };
  }, []);
  return m;
}
